// Intent: ONE place that knows where the pol_transfers backend lives and what its
// ApiResponse envelope looks like ({status, message, data}). Screens never fetch()
// directly — when the backend URL or envelope changes, only this file moves.
// EXPO_PUBLIC_API_URL unset (local web preview, backend not booted) => callers
// fall back to the mock transport in auth-api.ts.

export const API_URL: string | null = process.env.EXPO_PUBLIC_API_URL ?? null;

/** Mirror of pol_transfers utils/ApiResponse. */
export interface ApiEnvelope<T> {
  status: boolean;
  message: string | null;
  data: T | null;
}

export async function postJson<T>(
  path: string,
  body: unknown,
  accessToken?: string,
): Promise<ApiEnvelope<T>> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    return (await response.json()) as ApiEnvelope<T>;
  } catch {
    // Offline / server down: a calm Polish message instead of a crash — the app
    // is offline-first by design, login is the only thing that needs the network.
    return { status: false, message: 'Brak połączenia z serwerem. Spróbuj ponownie.', data: null };
  }
}
